import { Grid } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { DateField, TextInput } from '../../components/form';
import ReadOnlyField from '../../components/form/readonly-field';
import { Order, OrderDetailsFormData, OrderStatus } from '../../types';
import OrderUpdateDialog, { OrderFormData } from './order-update-dialog';

interface OrderDetailsDialogProps {
  open: boolean;
  onClose: () => void;
  order: Order;
  onSubmit: (data: OrderDetailsFormData) => Promise<void>;
  isSubmitting?: boolean;
}

interface OrderDetailsFormProps {
  order: Order;
}

const OrderDetailsForm: React.FC<OrderDetailsFormProps> = ({ order }) => {
  const { control } = useFormContext<OrderDetailsFormData>();
  const isDraftStatus = order.status === OrderStatus.DRAFT;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <TextInput
          name="orderNumber"
          control={control}
          label="Order Number"
          isReadOnly={false}
          required={true}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextInput name="po" control={control} label="PO" isReadOnly={false} required={true} />
      </Grid>

      <Grid item xs={12}>
        <TextInput
          name="jobName"
          control={control}
          label="Job Name"
          isReadOnly={false}
          required={true}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <DateField
          name="orderDate"
          control={control}
          label="Order Date"
          isReadOnly={true}
          required={true}
          showTime={true}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        {isDraftStatus ? (
          <ReadOnlyField label="Due Date" value="In draft status" />
        ) : (
          <DateField
            name="dueDate"
            control={control}
            label="Due Date"
            isReadOnly={false}
            required={false}
          />
        )}
      </Grid>
    </Grid>
  );
};

const OrderDetailsDialog: React.FC<OrderDetailsDialogProps> = ({
  open,
  onClose,
  order,
  onSubmit,
  isSubmitting = false,
}) => {
  const handleSubmit = async (data: OrderFormData) => {
    await onSubmit(data as OrderDetailsFormData);
  };

  return (
    <OrderUpdateDialog
      open={open}
      onClose={onClose}
      order={order}
      title="Edit Order Details"
      schemaKey="details"
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
    >
      <OrderDetailsForm order={order} />
    </OrderUpdateDialog>
  );
};

export default OrderDetailsDialog;
